<template>
  <button :class="[classes, { 'd-none' : isHidden }]"
          @click="onBackHandler">
    <font-awesome-icon icon="chevron-left"
                       size="xs"></font-awesome-icon>
    <slot>Back</slot>
  </button>
</template>
<script>

export default {
  name: "BackButton",
  props: {
    classes: {
      type: String,
      default: "cta cta--primary--alt",
    },
    loc: {
      required: false,
      type: String,
      default: "HISTORY::BACK",
    },
  },
  computed: {
    hasHistory () {
      return window.history.length > 1;
    },
    isHidden () {
      return this.hasHistory === false && this.loc === "HISTORY::BACK";
    },
  },
  methods: {
    onBackHandler () {
      if ( this.loc === "HISTORY::BACK" ) {
        window.history.back();
      } else {
        window.location.href = this.loc;
      }
    },
  },
};
</script>
